export const SET_YEAR = 'SET_YEAR'
export const SET_QUARTER = 'SET_QUARTER'
export const SET_TYPE = 'SET_TYPE'
export const SET_MONTH = 'SET_MONTH'
export const FETCH_ITEM_LIST = 'FETCH_ITEM_LIST'
export const FETCH_ITEM_LIST_SUCCESS = 'FETCH_ITEM_LIST_SUCCESS'
export const FETCH_ITEM_LIST_ERROR = 'FETCH_ITEM_LIST_ERROR'
export const RESET_ITEM_LIST = 'RESET_ITEM_LIST'
export const ADD_ITEM = 'ADD_ITEM'
export const CHANGE_ITEM = 'CHANGE_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'